<template>
  <van-popup v-model="setScore">
    <div class="detailed-wrapper  padding-sm">
      <h3>打分细则</h3>
      <div v-html="content">

      </div>
      <h3>得分</h3>
      <van-field
        readonly
        clickable
        name="picker"
        :value="score"
        placeholder="点击选择得分"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <h3 v-if="scoreNum !== totalPoints  && scoreNum !== '' && scoreNum !== -1">扣分理由</h3>
      <van-field
        v-if="scoreNum !== totalPoints && scoreNum !== '' && scoreNum !== -1"
        v-model="remark"
        rows="3"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入扣分理由"
        show-word-limit
      />
      <div class="flex align-center justify-around margin-top-sm">
        <van-button type="default" class="w-40" round @click="closeScore">
          关闭
        </van-button>
        <van-button type="primary" class="w-40" round color="#368ad1" @click="saveScore">
          保存
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {getFourDetial, saveFourScore} from "@/api/expert";

export default {
  name: "setScore",
  data() {
    return {
      content: '',
      showPicker: false,
      columns: [],
      columnsList: [],
      score: '',
      scoreNum: '',
      remark: '',
      totalPoints: 0,
    }
  },
  props: {
    setScore: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    setId: {
      type: Number
    },
    setItem: {
      type: Object
    }
  },
  created() {

  },
  components: {},
  methods: {
    //  保存打分
    async saveScore() {
      if (this.scoreNum === '') return this.$toast('请进行打分')
      const state = await saveFourScore(
        this.$route.params.oid,
        this.setItem.one_id,
        this.setId,
        this.scoreNum,
        (this.scoreNum === -1 || this.scoreNum === this.totalPoints) ? '' : this.remark,
      )
      if (state.status === 200) {
        this.$emit('closeScore', true)
      }
    },
    //  关闭弹框
    closeScore() {
      this.$emit('closeScore', false)
    },
    //  选择打分
    onConfirm(value, index) {
      this.score = value;
      this.scoreNum = this.columnsList[index];
      this.showPicker = false;

    },
    async getFourDetail() {
      const res = await getFourDetial(this.setId)
      this.content = res.data.content.replaceAll('\n','<br/>')
      this.totalPoints = res.data.total_points
      this.columnsList = res.data.json.split(',').map(Number)
      this.columnsList.map(item => {
        if (item !== -1) {
          this.columns.push(item + '分')
        } else {
          this.columns.push('无涉指标')
        }
      })
    }
  },
  filters: {},
  watch: {
    setId() {
      if (this.setId) {
        this.getFourDetail()
        if (this.setItem && this.setItem.status === 1) {
          this.scoreNum = this.setItem.score
          this.score = this.setItem.score === -1 ? '无涉指标' : this.setItem.score + '分'
          this.remark = this.setItem.remark
        }
      } else {
        this.columnsList = []
        this.columns = []
        this.score = ''
        this.scoreNum = ''
        this.remark = ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
.detailed-wrapper {
  width: calc(100vw - 40px);
  height: 100vh;
  overflow-y: scroll;
  background: #fff;
  border-right: 8px;

  h3 {
    font-size: 18px;
    margin: 10px 0 5px;
  }
}
</style>
